import gql from 'graphql-tag';

export class FormInput {
  id: number;
  plateNumber: string;
  notes: string;
  grossWeight: number;
  payloadWeight: number;
  licenseFileId: number;
  collectorId: number;
  isApproved: boolean;
  approvedBy: string;
  approvedDate: Date;
  isActive: boolean;
  firstDate: Date;
  lastDate: Date;
  firstUser: string;
  lastUser: string;

  constructor() {
    this.id = undefined;
    this.plateNumber = undefined;
    this.notes = undefined;
    this.grossWeight = undefined;
    this.payloadWeight = undefined;
    this.licenseFileId = undefined;
    this.collectorId = undefined;
    this.isApproved = undefined;
    this.approvedBy = undefined;
    this.approvedDate = undefined;
    this.isActive = undefined;
    this.firstDate = undefined;
    this.lastDate = undefined;
    this.firstUser = undefined;
    this.lastUser = undefined;
  }
}
export const gqlGetQuery = gql`
  query getVehicles($limit: Int, $offset: Int, $order: String, $where: String) {
    getVehicles(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        plateNumber
        brand
        notes
        grossWeight
        payloadWeight
        legacyAppId
        licenseFileId
        isActive
        lastDate
        lastUser
        firstDate
        firstUser
        collectorId
        collector {
          id
          name
        }
        licenseFilesrepository {
          id
          mimeMediaType
          s3Key
        }
        isApproved
        approvedBy
        approvedDate
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getVehicleById($id: Int) {
    getVehicleById(id: $id) {
      id
      plateNumber
      brand
      notes
      grossWeight
      payloadWeight
      legacyAppId
      licenseFileId
      isApproved
      approvedBy
      approvedDate
      isActive
      lastDate
      lastUser
      firstDate
      firstUser
      collectorId
      collector {
        id
        name
      }
      licenseFilesrepository {
        id
        mimeMediaType
        s3Key
        fileName
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addVehicle($data: VehicleInput) {
    addVehicle(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateVehicle($data: VehicleInput) {
    updateVehicle(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteVehicle($id: Int) {
    deleteVehicle(id: $id)
  }
`;

export const gqlAccept = gql`
  mutation acceptVehicle($id: Int) {
    acceptVehicle(id: $id)
  }
`;
